module.exports = __webpack_public_path__ + "static/img/dataLoss.a3c85570.png";